/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Unknown 1 = Low 2 = Medium 3 = High 4 = Custom
 */
export type BrowserFingerprintAggression = 0 | 1 | 2 | 3 | 4;

export const BrowserFingerprintAggression = {
  Unknown: 0 as BrowserFingerprintAggression,
  Low: 1 as BrowserFingerprintAggression,
  Medium: 2 as BrowserFingerprintAggression,
  High: 3 as BrowserFingerprintAggression,
  Custom: 4 as BrowserFingerprintAggression,
};
